/**
 * @generated SignedSource<<eb5e296bd28413c170c1d4a8b9a4b545>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "arriveBy"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "bikeSpeed"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "date"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "fromPlace"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "maxWalkDistance"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "minTransferTime"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "modes"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numItineraries"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "optimize"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ticketTypes"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "time"
},
v11 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "toPlace"
},
v12 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "transferPenalty"
},
v13 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "unpreferred"
},
v14 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "walkBoardCost"
},
v15 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "walkReluctance"
},
v16 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "walkSpeed"
},
v17 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "wheelchair"
},
v18 = [
  {
    "kind": "Variable",
    "name": "allowedTicketTypes",
    "variableName": "ticketTypes"
  },
  {
    "kind": "Variable",
    "name": "arriveBy",
    "variableName": "arriveBy"
  },
  {
    "kind": "Variable",
    "name": "bikeSpeed",
    "variableName": "bikeSpeed"
  },
  {
    "kind": "Variable",
    "name": "date",
    "variableName": "date"
  },
  {
    "kind": "Variable",
    "name": "fromPlace",
    "variableName": "fromPlace"
  },
  {
    "kind": "Variable",
    "name": "maxWalkDistance",
    "variableName": "maxWalkDistance"
  },
  {
    "kind": "Variable",
    "name": "minTransferTime",
    "variableName": "minTransferTime"
  },
  {
    "kind": "Variable",
    "name": "numItineraries",
    "variableName": "numItineraries"
  },
  {
    "kind": "Variable",
    "name": "optimize",
    "variableName": "optimize"
  },
  {
    "kind": "Variable",
    "name": "time",
    "variableName": "time"
  },
  {
    "kind": "Variable",
    "name": "toPlace",
    "variableName": "toPlace"
  },
  {
    "kind": "Variable",
    "name": "transferPenalty",
    "variableName": "transferPenalty"
  },
  {
    "kind": "Variable",
    "name": "transportModes",
    "variableName": "modes"
  },
  {
    "kind": "Variable",
    "name": "unpreferred",
    "variableName": "unpreferred"
  },
  {
    "kind": "Variable",
    "name": "walkBoardCost",
    "variableName": "walkBoardCost"
  },
  {
    "kind": "Variable",
    "name": "walkReluctance",
    "variableName": "walkReluctance"
  },
  {
    "kind": "Variable",
    "name": "walkSpeed",
    "variableName": "walkSpeed"
  },
  {
    "kind": "Variable",
    "name": "wheelchair",
    "variableName": "wheelchair"
  }
],
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "duration",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "startTime",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "endTime",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mode",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "transitLeg",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "points",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "gtfsId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "shortName",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "type",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "directionId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "scheduledDeparture",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "pickupType",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lon",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "zoneId",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "concreteType": "Stop",
  "kind": "LinkedField",
  "name": "stop",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v34/*: any*/)
  ],
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "stationId",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bikesAvailable",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "networks",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "bikeParkId",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "carParkId",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "color",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "fareUrl",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "desc",
  "storageKey": null
},
v45 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "alertSeverityLevel",
  "storageKey": null
},
v46 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveEndDate",
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "effectiveStartDate",
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "concreteType": "Alert",
  "kind": "LinkedField",
  "name": "alerts",
  "plural": true,
  "selections": [
    (v45/*: any*/),
    (v46/*: any*/),
    (v47/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertHeaderText",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "alertDescriptionText",
      "storageKey": null
    },
    (v42/*: any*/)
  ],
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vertexType",
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "BikeRentalStation",
  "kind": "LinkedField",
  "name": "bikeRentalStation",
  "plural": false,
  "selections": [
    (v36/*: any*/),
    (v31/*: any*/),
    (v32/*: any*/),
    (v33/*: any*/),
    (v37/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "spacesAvailable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "state",
      "storageKey": null
    },
    (v38/*: any*/),
    (v42/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "code",
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "platformCode",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vehicleMode",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "concreteType": "BikePark",
  "kind": "LinkedField",
  "name": "bikePark",
  "plural": false,
  "selections": [
    (v39/*: any*/),
    (v31/*: any*/),
    (v42/*: any*/)
  ],
  "storageKey": null
},
v55 = {
  "alias": null,
  "args": null,
  "concreteType": "Stop",
  "kind": "LinkedField",
  "name": "stop",
  "plural": false,
  "selections": [
    (v25/*: any*/),
    (v42/*: any*/)
  ],
  "storageKey": null
},
v56 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "realtimeState",
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cents",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v11/*: any*/),
      (v12/*: any*/),
      (v13/*: any*/),
      (v14/*: any*/),
      (v15/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "queryUtils_SummaryPage_moreItins_Query",
    "selections": [
      {
        "alias": null,
        "args": (v18/*: any*/),
        "concreteType": "Plan",
        "kind": "LinkedField",
        "name": "plan",
        "plural": false,
        "selections": [
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "SummaryPlanContainer_plan"
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ItineraryTab_plan"
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Itinerary",
            "kind": "LinkedField",
            "name": "itineraries",
            "plural": true,
            "selections": [
              (v19/*: any*/),
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ItineraryTab_itinerary"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "SummaryPlanContainer_itineraries"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Leg",
                "kind": "LinkedField",
                "name": "legs",
                "plural": true,
                "selections": [
                  (v22/*: any*/),
                  {
                    "args": null,
                    "kind": "FragmentSpread",
                    "name": "ItineraryLine_legs"
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Geometry",
                    "kind": "LinkedField",
                    "name": "legGeometry",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Route",
                    "kind": "LinkedField",
                    "name": "route",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v26/*: any*/),
                      (v27/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Trip",
                    "kind": "LinkedField",
                    "name": "trip",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stoptime",
                        "kind": "LinkedField",
                        "name": "stoptimesForDate",
                        "plural": true,
                        "selections": [
                          (v29/*: any*/),
                          (v30/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pattern",
                        "kind": "LinkedField",
                        "name": "pattern",
                        "plural": false,
                        "selections": [
                          {
                            "args": null,
                            "kind": "FragmentSpread",
                            "name": "RouteLine_pattern"
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "from",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BikeRentalStation",
                        "kind": "LinkedField",
                        "name": "bikeRentalStation",
                        "plural": false,
                        "selections": [
                          (v36/*: any*/),
                          (v37/*: any*/),
                          (v38/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "to",
                    "plural": false,
                    "selections": [
                      (v35/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "BikePark",
                        "kind": "LinkedField",
                        "name": "bikePark",
                        "plural": false,
                        "selections": [
                          (v39/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CarPark",
                        "kind": "LinkedField",
                        "name": "carPark",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v31/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "QueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v11/*: any*/),
      (v7/*: any*/),
      (v6/*: any*/),
      (v2/*: any*/),
      (v10/*: any*/),
      (v15/*: any*/),
      (v4/*: any*/),
      (v14/*: any*/),
      (v5/*: any*/),
      (v16/*: any*/),
      (v17/*: any*/),
      (v9/*: any*/),
      (v0/*: any*/),
      (v12/*: any*/),
      (v1/*: any*/),
      (v8/*: any*/),
      (v13/*: any*/)
    ],
    "kind": "Operation",
    "name": "queryUtils_SummaryPage_moreItins_Query",
    "selections": [
      {
        "alias": null,
        "args": (v18/*: any*/),
        "concreteType": "Plan",
        "kind": "LinkedField",
        "name": "plan",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "date",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "Itinerary",
            "kind": "LinkedField",
            "name": "itineraries",
            "plural": true,
            "selections": [
              (v20/*: any*/),
              (v21/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Leg",
                "kind": "LinkedField",
                "name": "legs",
                "plural": true,
                "selections": [
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "rentedBike",
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  (v21/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "distance",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Geometry",
                    "kind": "LinkedField",
                    "name": "legGeometry",
                    "plural": false,
                    "selections": [
                      (v24/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "length",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v23/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "interlineWithPreviousLeg",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Route",
                    "kind": "LinkedField",
                    "name": "route",
                    "plural": false,
                    "selections": [
                      (v26/*: any*/),
                      (v41/*: any*/),
                      (v27/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Agency",
                        "kind": "LinkedField",
                        "name": "agency",
                        "plural": false,
                        "selections": [
                          (v31/*: any*/),
                          (v42/*: any*/),
                          (v25/*: any*/),
                          (v43/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "phone",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "longName",
                        "storageKey": null
                      },
                      (v44/*: any*/),
                      (v48/*: any*/),
                      (v22/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "from",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v31/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stop",
                        "kind": "LinkedField",
                        "name": "stop",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v42/*: any*/),
                          (v34/*: any*/),
                          (v53/*: any*/),
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v54/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "to",
                    "plural": false,
                    "selections": [
                      (v32/*: any*/),
                      (v33/*: any*/),
                      (v31/*: any*/),
                      (v49/*: any*/),
                      (v50/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stop",
                        "kind": "LinkedField",
                        "name": "stop",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v42/*: any*/),
                          (v34/*: any*/),
                          (v31/*: any*/),
                          (v53/*: any*/),
                          (v48/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v54/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "CarPark",
                        "kind": "LinkedField",
                        "name": "carPark",
                        "plural": false,
                        "selections": [
                          (v40/*: any*/),
                          (v31/*: any*/),
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Trip",
                    "kind": "LinkedField",
                    "name": "trip",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stoptime",
                        "kind": "LinkedField",
                        "name": "stoptimes",
                        "plural": true,
                        "selections": [
                          (v55/*: any*/),
                          (v30/*: any*/),
                          (v56/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v42/*: any*/),
                      (v25/*: any*/),
                      (v28/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stoptime",
                        "kind": "LinkedField",
                        "name": "stoptimesForDate",
                        "plural": true,
                        "selections": [
                          (v29/*: any*/),
                          (v30/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "headsign",
                            "storageKey": null
                          },
                          (v56/*: any*/),
                          (v55/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Pattern",
                        "kind": "LinkedField",
                        "name": "pattern",
                        "plural": false,
                        "selections": [
                          (v51/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Coordinates",
                            "kind": "LinkedField",
                            "name": "geometry",
                            "plural": true,
                            "selections": [
                              (v32/*: any*/),
                              (v33/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Route",
                            "kind": "LinkedField",
                            "name": "route",
                            "plural": false,
                            "selections": [
                              (v22/*: any*/),
                              (v27/*: any*/),
                              (v41/*: any*/),
                              (v42/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Stop",
                            "kind": "LinkedField",
                            "name": "stops",
                            "plural": true,
                            "selections": [
                              (v32/*: any*/),
                              (v33/*: any*/),
                              (v31/*: any*/),
                              (v25/*: any*/),
                              (v52/*: any*/),
                              (v51/*: any*/),
                              (v44/*: any*/),
                              (v34/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Alert",
                                "kind": "LinkedField",
                                "name": "alerts",
                                "plural": true,
                                "selections": [
                                  (v45/*: any*/),
                                  (v46/*: any*/),
                                  (v47/*: any*/),
                                  (v42/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Stop",
                                "kind": "LinkedField",
                                "name": "stops",
                                "plural": true,
                                "selections": [
                                  (v31/*: any*/),
                                  (v44/*: any*/),
                                  (v42/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v42/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "tripHeadsign",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Place",
                    "kind": "LinkedField",
                    "name": "intermediatePlaces",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "arrivalTime",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Stop",
                        "kind": "LinkedField",
                        "name": "stop",
                        "plural": false,
                        "selections": [
                          (v25/*: any*/),
                          (v32/*: any*/),
                          (v33/*: any*/),
                          (v31/*: any*/),
                          (v51/*: any*/),
                          (v52/*: any*/),
                          (v42/*: any*/),
                          (v34/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Agency",
                    "kind": "LinkedField",
                    "name": "agency",
                    "plural": false,
                    "selections": [
                      (v31/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "url",
                        "storageKey": null
                      },
                      (v43/*: any*/),
                      (v42/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "realTime",
                    "storageKey": null
                  },
                  (v56/*: any*/),
                  (v19/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "intermediatePlace",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              (v19/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "walkDistance",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "fare",
                "kind": "LinkedField",
                "name": "fares",
                "plural": true,
                "selections": [
                  (v57/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "fareComponent",
                    "kind": "LinkedField",
                    "name": "components",
                    "plural": true,
                    "selections": [
                      (v57/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "fareId",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Route",
                        "kind": "LinkedField",
                        "name": "routes",
                        "plural": true,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Agency",
                            "kind": "LinkedField",
                            "name": "agency",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              (v43/*: any*/),
                              (v31/*: any*/),
                              (v42/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v25/*: any*/),
                          (v42/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v27/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3a5c7b1a82ec9f3a8ec2822e78fb2eb7",
    "id": null,
    "metadata": {},
    "name": "queryUtils_SummaryPage_moreItins_Query",
    "operationKind": "query",
    "text": "query queryUtils_SummaryPage_moreItins_Query(\n  $fromPlace: String!\n  $toPlace: String!\n  $numItineraries: Int!\n  $modes: [TransportMode!]\n  $date: String!\n  $time: String!\n  $walkReluctance: Float\n  $maxWalkDistance: Float\n  $walkBoardCost: Int\n  $minTransferTime: Int\n  $walkSpeed: Float\n  $wheelchair: Boolean\n  $ticketTypes: [String]\n  $arriveBy: Boolean\n  $transferPenalty: Int\n  $bikeSpeed: Float\n  $optimize: OptimizeType\n  $unpreferred: InputUnpreferred\n) {\n  plan(fromPlace: $fromPlace, toPlace: $toPlace, numItineraries: $numItineraries, transportModes: $modes, date: $date, time: $time, walkReluctance: $walkReluctance, maxWalkDistance: $maxWalkDistance, walkBoardCost: $walkBoardCost, minTransferTime: $minTransferTime, walkSpeed: $walkSpeed, wheelchair: $wheelchair, allowedTicketTypes: $ticketTypes, arriveBy: $arriveBy, transferPenalty: $transferPenalty, bikeSpeed: $bikeSpeed, optimize: $optimize, unpreferred: $unpreferred) {\n    ...SummaryPlanContainer_plan\n    ...ItineraryTab_plan\n    itineraries {\n      duration\n      startTime\n      endTime\n      ...ItineraryTab_itinerary\n      ...SummaryPlanContainer_itineraries\n      legs {\n        mode\n        ...ItineraryLine_legs\n        transitLeg\n        legGeometry {\n          points\n        }\n        route {\n          gtfsId\n          shortName\n          type\n          id\n        }\n        trip {\n          gtfsId\n          directionId\n          stoptimesForDate {\n            scheduledDeparture\n            pickupType\n          }\n          pattern {\n            ...RouteLine_pattern\n            id\n          }\n          id\n        }\n        from {\n          name\n          lat\n          lon\n          stop {\n            gtfsId\n            zoneId\n            id\n          }\n          bikeRentalStation {\n            stationId\n            bikesAvailable\n            networks\n            id\n          }\n        }\n        to {\n          stop {\n            gtfsId\n            zoneId\n            id\n          }\n          bikePark {\n            bikeParkId\n            name\n            id\n          }\n          carPark {\n            carParkId\n            name\n            id\n          }\n        }\n      }\n    }\n  }\n}\n\nfragment ItineraryLine_legs on Leg {\n  mode\n  rentedBike\n  startTime\n  endTime\n  distance\n  legGeometry {\n    points\n  }\n  transitLeg\n  interlineWithPreviousLeg\n  route {\n    shortName\n    color\n    type\n    agency {\n      name\n      id\n    }\n    id\n  }\n  from {\n    lat\n    lon\n    name\n    vertexType\n    bikeRentalStation {\n      stationId\n      name\n      lat\n      lon\n      bikesAvailable\n      spacesAvailable\n      state\n      networks\n      id\n    }\n    stop {\n      gtfsId\n      code\n      platformCode\n      id\n    }\n  }\n  to {\n    lat\n    lon\n    name\n    vertexType\n    bikeRentalStation {\n      stationId\n      name\n      lat\n      lon\n      bikesAvailable\n      spacesAvailable\n      state\n      networks\n      id\n    }\n    stop {\n      gtfsId\n      code\n      platformCode\n      id\n    }\n  }\n  trip {\n    stoptimes {\n      stop {\n        gtfsId\n        id\n      }\n      pickupType\n    }\n    id\n  }\n  intermediatePlaces {\n    arrivalTime\n    stop {\n      gtfsId\n      lat\n      lon\n      name\n      code\n      platformCode\n      id\n    }\n  }\n}\n\nfragment ItinerarySummaryListContainer_itineraries on Itinerary {\n  walkDistance\n  startTime\n  endTime\n  legs {\n    realTime\n    realtimeState\n    transitLeg\n    startTime\n    endTime\n    mode\n    distance\n    duration\n    rentedBike\n    interlineWithPreviousLeg\n    intermediatePlace\n    intermediatePlaces {\n      stop {\n        zoneId\n        id\n      }\n    }\n    route {\n      mode\n      shortName\n      type\n      color\n      agency {\n        name\n        id\n      }\n      alerts {\n        alertSeverityLevel\n        effectiveEndDate\n        effectiveStartDate\n        id\n      }\n      id\n    }\n    trip {\n      pattern {\n        code\n        id\n      }\n      stoptimes {\n        realtimeState\n        stop {\n          gtfsId\n          id\n        }\n        pickupType\n      }\n      id\n    }\n    from {\n      name\n      lat\n      lon\n      stop {\n        gtfsId\n        zoneId\n        platformCode\n        alerts {\n          alertSeverityLevel\n          effectiveEndDate\n          effectiveStartDate\n          id\n        }\n        id\n      }\n      bikeRentalStation {\n        bikesAvailable\n        networks\n        id\n      }\n    }\n    to {\n      stop {\n        gtfsId\n        zoneId\n        alerts {\n          alertSeverityLevel\n          effectiveEndDate\n          effectiveStartDate\n          id\n        }\n        id\n      }\n      bikePark {\n        bikeParkId\n        name\n        id\n      }\n      carPark {\n        carParkId\n        name\n        id\n      }\n    }\n  }\n}\n\nfragment ItineraryTab_itinerary on Itinerary {\n  walkDistance\n  duration\n  startTime\n  endTime\n  fares {\n    cents\n    components {\n      cents\n      fareId\n      routes {\n        agency {\n          gtfsId\n          fareUrl\n          name\n          id\n        }\n        gtfsId\n        id\n      }\n    }\n    type\n  }\n  legs {\n    mode\n    ...LegAgencyInfo_leg\n    from {\n      lat\n      lon\n      name\n      vertexType\n      bikePark {\n        bikeParkId\n        name\n        id\n      }\n      bikeRentalStation {\n        networks\n        bikesAvailable\n        lat\n        lon\n        stationId\n        id\n      }\n      stop {\n        gtfsId\n        code\n        platformCode\n        vehicleMode\n        zoneId\n        alerts {\n          alertSeverityLevel\n          effectiveEndDate\n          effectiveStartDate\n          alertHeaderText\n          alertDescriptionText\n          id\n        }\n        id\n      }\n    }\n    to {\n      lat\n      lon\n      name\n      vertexType\n      bikeRentalStation {\n        lat\n        lon\n        stationId\n        networks\n        bikesAvailable\n        id\n      }\n      stop {\n        gtfsId\n        code\n        platformCode\n        zoneId\n        name\n        vehicleMode\n        alerts {\n          alertSeverityLevel\n          effectiveEndDate\n          effectiveStartDate\n          alertHeaderText\n          alertDescriptionText\n          id\n        }\n        id\n      }\n      bikePark {\n        bikeParkId\n        name\n        id\n      }\n      carPark {\n        carParkId\n        name\n        id\n      }\n    }\n    legGeometry {\n      length\n      points\n    }\n    intermediatePlaces {\n      arrivalTime\n      stop {\n        gtfsId\n        lat\n        lon\n        name\n        code\n        platformCode\n        zoneId\n        id\n      }\n    }\n    realTime\n    realtimeState\n    transitLeg\n    rentedBike\n    startTime\n    endTime\n    interlineWithPreviousLeg\n    distance\n    duration\n    intermediatePlace\n    route {\n      shortName\n      color\n      gtfsId\n      type\n      longName\n      desc\n      agency {\n        gtfsId\n        fareUrl\n        name\n        phone\n        id\n      }\n      alerts {\n        alertSeverityLevel\n        effectiveEndDate\n        effectiveStartDate\n        alertHeaderText\n        alertDescriptionText\n        id\n      }\n      id\n    }\n    trip {\n      gtfsId\n      tripHeadsign\n      pattern {\n        code\n        id\n      }\n      stoptimesForDate {\n        headsign\n        pickupType\n        realtimeState\n        stop {\n          gtfsId\n          id\n        }\n      }\n      id\n    }\n  }\n}\n\nfragment ItineraryTab_plan on Plan {\n  date\n}\n\nfragment LegAgencyInfo_leg on Leg {\n  agency {\n    name\n    url\n    fareUrl\n    id\n  }\n}\n\nfragment RouteLine_pattern on Pattern {\n  code\n  geometry {\n    lat\n    lon\n  }\n  route {\n    mode\n    type\n    color\n    id\n  }\n  stops {\n    lat\n    lon\n    name\n    gtfsId\n    platformCode\n    code\n    ...StopCardHeaderContainer_stop\n    id\n  }\n}\n\nfragment StopCardHeaderContainer_stop on Stop {\n  gtfsId\n  name\n  code\n  desc\n  zoneId\n  alerts {\n    alertSeverityLevel\n    effectiveEndDate\n    effectiveStartDate\n    id\n  }\n  lat\n  lon\n  stops {\n    name\n    desc\n    id\n  }\n}\n\nfragment SummaryPlanContainer_itineraries on Itinerary {\n  ...ItinerarySummaryListContainer_itineraries\n  endTime\n  startTime\n  legs {\n    mode\n    to {\n      bikePark {\n        bikeParkId\n        name\n        id\n      }\n    }\n    ...ItineraryLine_legs\n    transitLeg\n    legGeometry {\n      points\n    }\n    route {\n      gtfsId\n      id\n    }\n    trip {\n      gtfsId\n      directionId\n      stoptimesForDate {\n        scheduledDeparture\n      }\n      pattern {\n        ...RouteLine_pattern\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment SummaryPlanContainer_plan on Plan {\n  date\n  itineraries {\n    startTime\n    endTime\n    legs {\n      mode\n      ...ItineraryLine_legs\n      transitLeg\n      legGeometry {\n        points\n      }\n      route {\n        gtfsId\n        id\n      }\n      trip {\n        gtfsId\n        directionId\n        stoptimesForDate {\n          scheduledDeparture\n          pickupType\n        }\n        pattern {\n          ...RouteLine_pattern\n          id\n        }\n        id\n      }\n      from {\n        name\n        lat\n        lon\n        stop {\n          gtfsId\n          zoneId\n          id\n        }\n        bikeRentalStation {\n          bikesAvailable\n          networks\n          id\n        }\n      }\n      to {\n        stop {\n          gtfsId\n          zoneId\n          id\n        }\n        bikePark {\n          bikeParkId\n          name\n          id\n        }\n      }\n    }\n  }\n}\n"
  }
};
})();

node.hash = "0f8db983cd3ba6d2c8fed18cb19d970c";

module.exports = node;
